module.exports = __webpack_public_path__ + "img/D4.0820ef25.svg";